import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const UserIcon = ({
  title = 'User',
  viewBox = '0 0 14 19',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props} fill="none">
    <path
      d="M7 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM2 5a5 5 0 1 1 10 0A5 5 0 0 1 2 5Zm3 8a3 3 0 0 0-3 3v2a1 1 0 1 1-2 0v-2a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5v2a1 1 0 1 1-2 0v-2a3 3 0 0 0-3-3H5Z"
      fill="currentColor"
    />
  </CreateIconComponent>
);

export default UserIcon;
